import {
    getPayments,
    deletePayment,
    createPayment,
    updatePayment,
    getReportPayments
} from '../../../services/PaymentService';
import {
    CONFIRMED_GET_PAYMENTS
} from './PaymentTypes';

export function getPaymentsAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'PAYMENTS_LOADING' });
        getPayments(currentPage, pageSize, searchTerm, filterQuery).then((response) => {
            dispatch(confirmedGetPaymentsAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'PAYMENTS_LOADED' });
        });
    };
}

export function getReportPaymentsAction(filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'PAYMENTS_LOADING' });
        getReportPayments(filterQuery).then((response) => {
            dispatch(confirmedGetPaymentsAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'PAYMENTS_LOADED' });
        });
    };
}

export function confirmedGetPaymentsAction(data) {
    return {
        type: CONFIRMED_GET_PAYMENTS,
        payload: data,
    };
}

export function deletePaymentAction(id, history) {
    return (dispatch, getState) => {
        return deletePayment(id).then((response) => {
            return response;
        });
    };
}

export function createPaymentAction(data) {
    return () => {
        return createPayment(data).then((response) => {
            return response;
        });
    };
}

export function updatePaymentAction(id, data) {
    return () => {
        return updatePayment(id, data).then((response) => {
            return response;
        });
    };
}
